import { createContext } from "react"
import { defaultXAxisContextValue } from "./defaultXAxisContextValue"
import type { XAxisContextValue } from "./XAxisContextValue"

export const XAxisContext = createContext<XAxisContextValue>(
  defaultXAxisContextValue,
)
